module.exports = __webpack_public_path__ + "tooltip1.dc52b301c0f1de0f7bd0.svg";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/images/tooltip/tooltip1.svg
// module id = ../../../../../src/assets/images/tooltip/tooltip1.svg
// module chunks = styles